import { render, staticRenderFns } from "./calcdetail.vue?vue&type=template&id=4b0c117c&scoped=true"
import script from "./calcdetail.vue?vue&type=script&lang=js"
export * from "./calcdetail.vue?vue&type=script&lang=js"
import style0 from "./calcdetail.vue?vue&type=style&index=0&id=4b0c117c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b0c117c",
  null
  
)

export default component.exports